// extracted by mini-css-extract-plugin
export default {"container":"PlayerInfo_container__edROt","row":"PlayerInfo_row__mk1tG","col":"PlayerInfo_col__UTz4p","label":"PlayerInfo_label__lbIaz","value":"PlayerInfo_value__SM3xQ"};